// /* global IS_PRODUCTION */

import React from 'react';
import { render } from 'react-dom';

import BaseModule from '../../../javascripts/helpers/baseModule';

import App from './components/App.jsx';

export default class Location extends BaseModule {
  constructor(element, options = {}) {
    super(element, 'location');
    this.options = options;
  }

  // triggered once in BaseModule
  init() {
    // Make sure we have valid elements
    if (!this.elements || !this.elements.self) {
      console.error('Location component: elements not properly initialized');
      return;
    }

    try {
      // Get data from options or data attribute
      let data;
      if (this.options && this.options.data) {
        data = this.options.data;
      } else if (this.elements.self.dataset && this.elements.self.dataset.jsModuleConfig) {
        data = JSON.parse(this.elements.self.dataset.jsModuleConfig);
      } else {
        console.error('Location component: No data available');
        return;
      }

      // Ensure language property is set
      if (!data.language) {
        // Try to get from parent data-language attribute
        const languageAttr = this.elements.self.closest('[data-language]');
        data.language = languageAttr ? languageAttr.dataset.language : 'de';
      }

      render(<App data={data} />, this.elements.self);
    } catch (error) {
      console.error('Error initializing Location component:', error);
    }
  }
}
